import * as XLSX from "xlsx";

export function downloadStaticReport(response) {
  const trainingData = response.map((data) => {
    return [
      data.title ?? "", // Training Title
      data.trainingTopic ?? "", // Training Topic
      data.trainingtype?.title ?? "", // Training Type
      data.trainerCount ?? "", // trainer
      data.traineeCount ?? "", // trainee
      data.genderCount.male ?? "",
      data.genderCount.female ?? "",
      data.genderCount.other ?? "",
      data.prePercentage ?? "",
      data.postPercentage ?? "",
      knowledgeChange(data),
      data.noofdays ?? "", // Days
      data.thematic_id ?? "", // Thematic Area
      data.subprogram_id ?? "", // Subprogram
      data.project_id ?? "", // Project
      data.advisor_id ?? "", // Advisor
      data.programofficer_id ?? "", // Program Officer
      data.doner_id ?? "", // Doner
      data.startdate ?? "", // Start Date
      data.enddate ?? "", // End Date
      data.district_id ?? "", // Location
      data.venue ?? "", // Venue
    ];
  });

  const headers = [
    "Event Title",
    "Event Topic",
    "Event Type",
    "Facilitators",
    "Participants",
    "Male Participants",
    "Female Participants",
    "Other Participants",
    "Pre Percentage",
    "Post Percentage",
    "Knowledge Change",
    "Days",
    "Thematic Area",
    "Subprogramme",
    "Project",
    "Advisor",
    "Program Officer",
    "Donors",
    "Start Date",
    "End Date",
    "Location",
    "Venue",
  ];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = XLSX.utils.book_new();
  // Add a worksheet with the data
  const ws = XLSX.utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:v1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Statistical Report.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

function knowledgeChange(data) {
  const { postPercentage, prePercentage } = data;
  // Check for null, NaN, or zero to avoid division errors
  if (postPercentage == 0 || prePercentage == 0) {
    return "";
  }
  const percentageChange = Math.round(
    ((postPercentage - prePercentage) / prePercentage) * 100
  );
  return `${percentageChange}%`;
}

export function downloadTraineeList(response) {
  const trainingData = response.map((data) => {
    return [
      data.name ?? "",
      data.email ?? "",
      data.gender ?? "",
      data.cnic ?? "",
      data.contactNo ?? "",
      data.profession ?? "",
      data.designation ?? "",
      data.department ?? "",
      data.institution ?? "",
      data.potentialTrainer ? 'Yes' : 'No',
      data.sector ?? "",
      data.address ?? "",
      data.district ?? "",
      data.province ?? "",
      data.country ?? "",
      data.username ?? "",
    ];
  });

  const headers = [
    "Name",
    "Email",
    "Gender",
    "CNIC",
    "Contact No",
    "Profession",
    "Designation",
    "Department",
    "Institution",
    "Potential Trainer",
    "Sector",
    "Address",
    "District",
    "Province",
    "Country",
    "Username",
  ];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = XLSX.utils.book_new();
  // Add a worksheet with the data
  const ws = XLSX.utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:P1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Participants List.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export function downloadTrainerList(response) {
  const trainingData = response.map((data) => {
    return [
      data.name ?? "",
      data.email ?? "",
      data.gender ?? "",
      data.cnic ?? "",
      data.mobile ?? "",
      data.designation ?? "",
      data.department ?? "",
      data.qualification ?? "",
      data.address ?? "",
      data.nationality ?? "",
    ];
  });

  const headers = [
    "Name",
    "Email",
    "Gender",
    "CNIC",
    "Contact No",
    "Designation",
    "Department",
    "Qualification",
    "Address",
    "Nationality",
  ];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = XLSX.utils.book_new();
  // Add a worksheet with the data
  const ws = XLSX.utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:P1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Facilitator List.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
